import { useEffect, useState } from "react";
import { Area, AreaChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Eye, MousePointerClick, UserPlus } from "lucide-react";
import { useApi } from "@/lib/api";

const Stat = ({ icon: Icon, label, value, testId }) => (
  <div data-testid={testId} className="rounded-2xl border border-slate-200 bg-white p-6">
    <Icon size={18} className="text-blue-600" />
    <p className="mt-4 font-display text-3xl font-bold">{value}</p>
    <p className="text-sm text-slate-500">{label}</p>
  </div>
);

export const StatsTab = () => {
  const api = useApi();
  const [s, setS] = useState(null);
  useEffect(() => { api("get", "/me/stats").then(setS); }, [api]);
  if (!s) return <p className="text-sm text-slate-500">Caricamento statistiche...</p>;

  return (
    <div className="space-y-6">
      <div className="grid gap-4 sm:grid-cols-3">
        <Stat icon={Eye} label="Visualizzazioni" value={s.views} testId="stat-card-total-views" />
        <Stat icon={MousePointerClick} label="Click sui link" value={s.clicks} testId="stat-card-link-clicks" />
        <Stat icon={UserPlus} label="Salvataggi rubrica" value={s.vcards} testId="stat-card-vcards" />
      </div>
      <div className="rounded-2xl border border-slate-200 bg-white p-6 md:p-8">
        <h3 className="text-lg font-semibold">Visite ultimi 14 giorni</h3>
        <div className="mt-6 h-56" data-testid="stats-chart">
          <ResponsiveContainer>
            <AreaChart data={s.views_by_day.map((d) => ({ ...d, label: d.day.slice(8) + "/" + d.day.slice(5, 7) }))}>
              <defs><linearGradient id="g" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#2563EB" stopOpacity={0.3} /><stop offset="100%" stopColor="#2563EB" stopOpacity={0} /></linearGradient></defs>
              <XAxis dataKey="label" tick={{ fontSize: 11 }} axisLine={false} tickLine={false} />
              <YAxis allowDecimals={false} tick={{ fontSize: 11 }} axisLine={false} tickLine={false} width={28} />
              <Tooltip />
              <Area type="monotone" dataKey="views" name="Visite" stroke="#2563EB" strokeWidth={2} fill="url(#g)" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div className="rounded-2xl border border-slate-200 bg-white p-6 md:p-8">
        <h3 className="text-lg font-semibold">Click per elemento</h3>
        {s.clicks_by_target.length === 0 ? <p className="mt-4 text-sm text-slate-500">Nessun click registrato finora.</p> : (
          <div className="mt-6 space-y-3" data-testid="clicks-by-target">
            {s.clicks_by_target.map((c) => (
              <div key={c.target} className="flex items-center gap-4 text-sm">
                <span className="w-32 truncate font-medium capitalize">{c.target}</span>
                <div className="h-2 flex-1 overflow-hidden rounded-full bg-slate-100"><div className="h-full rounded-full bg-blue-600" style={{ width: `${(c.count / s.clicks_by_target[0].count) * 100}%` }} /></div>
                <span className="w-8 text-right font-mono-ui">{c.count}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
